export enum AUTH_PROVIDERS {
  DEFAULT = 'DEFAULT',
  OKTA = 'OKTA',
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
  AZURE = 'AZURE',
}

export const OKTA_CODE_CHALLENGE_METHOD = 'S256';
